import axios from '@/api/axios'
import { resourceConstructor } from '@/api'

const constructFullUrl = resourceConstructor('assignments')

export default {
  getAssignments: ({ params } = {}) =>
    axios.get(constructFullUrl(''), { params }),

  getAnalytics: () => axios.get(constructFullUrl('iqa-work-overview')),

  userIqaOverview: userId =>
    axios.get(constructFullUrl(`user-iqa-overview/${userId}`)),

  retrieveCourseAssignments: ({ userId, params }) =>
    axios.get(constructFullUrl(`user-detail/${userId}`), { params }),

  iqaProfessorOverview: ({ professorId }) =>
    axios.get(constructFullUrl(`professor-iqa-overview/${professorId}`)),

  listAssignments: ({ params }) =>
    axios.get(constructFullUrl(`assignment-users`), {
      params,
    }),

  getPreviousSubmissionsList: ({ assignmentId, studentId }) =>
    axios.get(constructFullUrl(`${assignmentId}/${studentId}/submissions/`)),

  getSubmissionById: submissionId =>
    axios.get(constructFullUrl(`submissions/${submissionId}/`)),

  getMarkedRubrics: ({ reviewId }) =>
    axios.get(constructFullUrl(`review-rubrics/${reviewId}/`)),

  getRubrics: ({ assignmentId }) =>
    axios.get(constructFullUrl(`pr/${assignmentId}/rubric/list/`)),

  submitReview: ({ reviewId, data }) =>
    axios.post(constructFullUrl(`review-evaluation/${reviewId}`), data),

  updateReview: ({ reviewId, data }) =>
    axios.put(constructFullUrl(`review-evaluation/${reviewId}`), data),

  getIQAMarkedRubrics: ({ reviewId }) =>
    axios.get(constructFullUrl(`iqa-review-rubrics/${reviewId}/`)),

  downloadAttachment: ({ attachmentId }) =>
    axios.get(constructFullUrl(`submissions/attachments/${attachmentId}/`)),
}
